<template>
    <div class="addBox relative">
        <div class="title">
            <div class="title_left"><span class="movePoin" @click="$router.go(-1)">人员管理</span>/<span class="type">查看详情</span></div>
        </div>
        <el-form label-width="150px">
			<ToggleForm title="基本信息">
				<div class="content">
					<div class="row mt20">
						<el-form-item label="姓名：">
							{{obj.realName}}
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="性别：">
                            {{obj.gender_r}}
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="身份证：">
                            {{obj.idCard}}
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="手机(账号)：">
                            {{obj.mobile}}
                        </el-form-item>
					</div>
                    <div class="row">
						<el-form-item label="工作岗位：">
							{{obj.post}}
						</el-form-item>
					</div>
				</div>
			</ToggleForm>
            <ToggleForm title="业务权限">
				<div class="content">
                    <div class="row mt20">
                        <el-form-item label=" 启用禁用：">
                            {{obj.avaliable==1?'启用':'禁用'}}
                        </el-form-item>
                    </div>
					<div class="row">
						<el-form-item label="业务权限：" prop="roleList">
                            {{roleListStr}}
						</el-form-item>
					</div>
					<div class="row">
						<el-form-item label="人员类别：" prop="roleList">
                              {{obj.employeeCategory_}}
						</el-form-item>
					</div>
				</div>
			</ToggleForm>
            <ToggleForm title="附件">
				<div class="content">
                    <div class="row mt20">
						<el-form-item label="健康证有效期至：" prop="roleList" class="clear_a">
                            {{obj.healthCertificateValidityPeriod}}
						</el-form-item>
					</div>
                    <div class="row rowybUpload">
                        <el-form-item label="健康证图片：">
                            <div class="imgbox" v-if="obj.healthCertificateFileId.length >= 1">
                                <div v-for="(item,index) in obj.healthCertificateFileId" @click.stop="ifbig(baseUrl+'/'+item.fileUrl)" class="imgdiv">
                                    <img :src="baseUrl+'/'+item.fileUrl">
                                    <span>预览</span>
                                </div>
                            </div>
                            <div class='big-img' v-show="showBigPic" @click.stop="ifbig('-1')">
                                <img :src="bigImgSrc">
                            </div>
                            <div v-if="obj.healthCertificateFileId.length == 0">
                                <span>暂无</span>
                            </div>    
                        </el-form-item>
                    </div>
                    <div class="row rowybUpload">
                        <el-form-item label="身份证图片：">
                            <div class="imgbox" v-if="obj.idCardFileId.length >= 1">
                                <div v-for="(item,index) in obj.idCardFileId" @click.stop="ifbig(baseUrl+'/'+item.fileUrl)" class="imgdiv">
                                    <img :src="baseUrl+'/'+item.fileUrl">
                                    <span>预览</span>
                                </div>
                            </div>
                            <div class='big-img' v-show="showBigPic" @click.stop="ifbig('-1')">
                                <img :src="bigImgSrc">
                            </div>
                            <div v-if="obj.idCardFileId.length == 0">
                                <span>暂无</span>
                            </div>    
                        </el-form-item>
                    </div>
				</div>
			</ToggleForm>
		</el-form>
		<div class="foot-btn">
			<div>
			<el-button class="w70 mr10" @click="$router.go(-1)">返回</el-button>
			<el-button type="primary w70 " @click="edit">编辑</el-button>
			</div>
		</div>
    </div>
</template>

<script>
import ToggleForm from "components/ToggleForm";
import { getMapping } from "@/utils/mapping";
import * as api from "api/personApi";
export default {
  name: "personDetail",
  components: { ToggleForm },
  data() {
    return {
      baseUrl:this.$store.state.common.baseUrl,
      id: "",
      bigImgSrc: null, //拍照图片查看路径
      showBigPic: false, //拍照图片查看是否显示
      obj: {},
      roleListStr: "",
      roleListArr: [
        { key: "01", label: "晨检公示" },
        { key: "02", label: "清洗消毒" },
        { key: "03", label: "食品留样" },
        { key: "04", label: "餐厨垃圾" },
        { key: "05", label: "食堂陪餐" },
        { key: "06", label: "教育培训" },
        //  {key:'07',label:'自检自查'},
        { key: "08", label: "每日菜谱" },
        { key: "16", label: "添加剂记录" },
        { key: "14", label: "进货查验" },
        { key: "1401", label: "进货查验-管理" },
        { key: "15", label: "出库登记" },
        { key: "1501", label: "出库登记-管理" }
      ]
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.init();
    } else {
      this.$message({
        message: "人员id错误，无法获取详情",
        type: "warning"
      });
    }
  },
  methods: {
    init() {
      api.personInfo(this.id).then(r => {
        if (r.code == 200) {
          this.obj = r.data;
          //   权限
          let str = "";
          this.roleListArr.forEach(item => {
            if (this.obj.roles.includes(item.key)) {
              str += item.label + ",";
            }
          });
          this.roleListStr = str.substring(0, str.length - 1);
          //   性别
          let result = getMapping().gender;
          this.obj.gender_r = result[this.obj.gender];
          //   身份证
          if (this.obj.idCard === null || this.obj.idCard == "") {
            this.obj.idCard = "暂无";
          }
          //   职员类别
          if (
            this.obj.employeeCategory == "" ||
            this.obj.employeeCategory === null
          ) {
            this.obj.employeeCategory = [];
          } else {
            this.obj.employeeCategory = this.obj.employeeCategory.split(",");
          }
          this.obj.employeeCategory_ = "";
          let employee = getMapping().employee;
          for (let i in employee) {
            if (this.obj.employeeCategory.includes(i)) {
              this.obj.employeeCategory_ += employee[i] + ",";
            }
          }
          this.obj.employeeCategory_ = this.obj.employeeCategory_.substring(
            0,
            this.obj.employeeCategory_.length - 1
          );

          //   健康证
          this.obj.healthCertificateFileId = [];
          if (
            this.obj.healthCertificateFileDto !== null &&
            this.obj.healthCertificateFileDto !== ""
          ) {
            this.obj.healthCertificateFileId.push(
              this.obj.healthCertificateFileDto
            );
          }
          //   健康证日期
          if (
            this.obj.healthCertificateValidityPeriod === null ||
            this.obj.healthCertificateValidityPeriod == ""
          ) {
            this.obj.healthCertificateValidityPeriod = "暂无";
          }
          //   身份证图片
          this.obj.idCardFileId = [];
          if (
            this.obj.idCardFileDto !== null &&
            this.obj.idCardFileDto !== ""
          ) {
            this.obj.idCardFileId.push(this.obj.idCardFileDto);
          }
        }
      });
    },
    edit() {
      this.$router.push({
        name: "person.addAndEdit",
        query: { type: "edit", id: this.id }
      });
    },
    ifbig(item) {
      if (this.bigImgSrc == null || this.bigImgSrc != item) {
        this.bigImgSrc = item;
        this.showBigPic = true;
      } else {
        this.bigImgSrc = null;
      }
      if (item == -1) {
        this.showBigPic = false;
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.addBox {
  width: calc(100% - 40px);
  min-height: 100%;
  padding: 0 20px 100px 20px;
  .title {
    height: 60px;
    line-height: 60px;
    .title_left {
      font-size: 20px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      width: 50%;
      height: 100%;
      .type {
        color: #70ce97;
      }
    }
  }
}
// 图片列表
.imgbox {
  // display: flex;
  width: 650px;
  // overflow: hidden;
}

.imgdiv {
  float: left;
  width: 130px;
  height: 130px;
  border: 1px solid #c2cad2;
  border-radius: 6px;
  position: relative;
  margin-right: 20px;
  margin-top: 10px;
  img {
    transition: all 0.5s;
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
  span {
    display: none;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0 0 5px 5px;
    font-size: 14px;
    color: #ffffff;
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
.imgdiv:hover {
  span {
    display: inline-block;
  }
}
.big-img {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  > img {
    display: block;
    max-height: 700px;
  }
}
</style>